import React, { useState } from "react";
import Video from "../../images/video (1).mp4";
import Particles from "react-particles-js";

import {
	HeroContainer,
	HeroBg,
	VideoBg,
	HeroContent,
	HeroTitle,
	HeroSubTitle,
} from "./HeroSection.elements";

function HeroSection() {
	const [mobile, setMobile] = useState(false);

	const showVideo = () => {
		if (window.innerWidth <= 960) {
			setMobile(true);
		} else {
			setMobile(false);
		}
	};

	window.addEventListener("resize", showVideo);
	console.log(mobile);
	return (
		<>
			<HeroContainer>
				<HeroBg>
					{mobile ? (
						<VideoBg autoPlay loop muted src={Video} type='video/mp4' />
					) : (
						<Particles
							params={{
								particles: {
									number: {
										value: 50,
										density: {
											enable: true,
											value_area: 500,
										},
									},
									color: {
										value: "#ffffff",
									},
									shape: {
										type: "circle",
										stroke: {
											width: 0,
											color: "#000000",
										},
										polygon: {
											nb_sides: 5,
										},
										image: {
											src: "img/github.svg",
											width: 100,
											height: 100,
										},
									},
									opacity: {
										value: 0.5,
										random: false,
										anim: {
											enable: false,
											speed: 1,
											opacity_min: 0.1,
											sync: false,
										},
									},
									size: {
										value: 3,
										random: true,
										anim: {
											enable: false,
											speed: 40,
											size_min: 0.1,
											sync: false,
										},
									},
									line_linked: {
										enable: true,
										distance: 150,
										color: "#ffffff",
										opacity: 0.4,
										width: 1,
									},
									move: {
										enable: true,
										speed: 2,
										direction: "none",
										random: true,
										straight: false,
										out_mode: "out",
										bounce: false,
										attract: {
											enable: false,
											rotateX: 600,
											rotateY: 1200,
										},
									},
								},
								// interactivity: {
								// 	detect_on: "canvas",
								// 	events: {
								// 		onhover: {
								// 			enable: true,
								// 			mode: "grab",
								// 		},
								// 		onclick: {
								// 			enable: true,
								// 			mode: "repulse",
								// 		},
								// 		resize: true,
								// 	},
								// 	modes: {
								// 		grab: {
								// 			distance: 200,
								// 			line_linked: {
								// 				opacity: 1,
								// 			},
								// 		},
								// 		bubble: {
								// 			distance: 400,
								// 			size: 40,
								// 			duration: 2,
								// 			opacity: 8,
								// 			speed: 3,
								// 		},
								// 		repulse: {
								// 			distance: 200,
								// 			duration: 0.4,
								// 		},
								// 		push: {
								// 			particles_nb: 4,
								// 		},
								// 		remove: {
								// 			particles_nb: 2,
								// 		},
								// 	},
								// },
								retina_detect: true,
							}}
						/>
					)}
					{/* <VideoBg autoPlay loop muted src={Video} type='video/mp4' /> */}
				</HeroBg>
				<HeroContent>
					<HeroTitle>DevScript Community</HeroTitle>
					<HeroSubTitle>Let us COME together to LEARN & GROW</HeroSubTitle>
				</HeroContent>
			</HeroContainer>
		</>
	);
}

export default HeroSection;
